import { useNavigate } from "react-router-dom";
import User from "../APIController/User";
import SyncHelper from '../Helper/SyncHelper';

const TokenValidator = () =>{
    const navigate = useNavigate();
    const {getUser} = User()
    const { pingRequest } = SyncHelper()

    const validateToken = async () =>{
        const token = localStorage.getItem("token");
        if (!token) {
            localStorage.removeItem("user");
            navigate("/app/login");
            return;
        }
        if (await pingRequest() === false) return;
        const response = await getUser()
        if (response.ok){
            return response
        } else{
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            navigate("/app/login");
        }
    }

    return {
        validateToken
    }
}
export default TokenValidator